/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExpiringItemDto } from '../../models/expiring-item-dto';

export interface StockReportsControllerGetExpiring$Params {
}

export function stockReportsControllerGetExpiring(http: HttpClient, rootUrl: string, params?: StockReportsControllerGetExpiring$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExpiringItemDto>>> {
  const rb = new RequestBuilder(rootUrl, stockReportsControllerGetExpiring.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExpiringItemDto>>;
    })
  );
}

stockReportsControllerGetExpiring.PATH = '/stock/reports/expiring';
